<div
	class="color-picker-box"
	[class.no-value]="!modelValue"
	[class.in-mat-form-field]="inMatFormField"
	[class.dark-theme]="theme === 'dark'"
>
	<div class="picker-container" (click)="openColorOverlay()">
		<div
			*ngIf="!useOverlay"
			#colorPicker
			class="color-preview"
			[cpPosition]="pickerPosition"
			[cpPositionOffset]="'50%'"
			[cpPositionRelativeToArrow]="true"
			[cpPresetColors]="colorPresets"
			[(colorPicker)]="modelValue"
			[(cpToggle)]="colorPickerToggle"
			[cpOutputFormat]="'hex'"
			[cpDisableInput]="false"
			(colorPickerChange)="onModelChange($event)"
		>
			<div class="inner" [style.background-color]="modelValue"></div>
			<div class="no-value" [hidden]="modelValue"></div>
		</div>
		<div *ngIf="useOverlay" class="color-preview">
			<div class="inner" [style.background-color]="modelValue"></div>
			<div class="no-value" [hidden]="modelValue"></div>
		</div>
	</div>
	<div *ngIf="!hideLabel" class="value-container">
		<span *ngIf="!useOverlay" class="value" (click)="colorPickerToggle = !colorPickerToggle">
			{{ modelValue }}
		</span>
		<input *ngIf="useOverlay" type="text" class="value" [(ngModel)]="modelValue" cdkOverlayOrigin #inputRef="cdkOverlayOrigin" (change)="onModelChange(modelValue)" />
		<span
			class="trash"
			(click)="onTrashClick()"
			*ngIf="!disableClear && modelValue && (!defaultIncludingHash || defaultIncludingHash !== modelValue)"
		>
			<i class="fa fa-close"></i>
		</span>
		<span *ngIf="defaultIncludingHash && defaultIncludingHash === modelValue" class="default"
			>({{ 'DEFAULT' | translate }})</span
		>
	</div>
</div>
